<template>
	<div class="addRoleDraw">
		<el-drawer :title="title" :visible.sync="drawer" :wrapperClosable="false" direction="rtl" :before-close="handleClose" size="724px">
			<div v-loading="loading">
				<p class="mt-24 ml-24 yx-color-text-primary font-h4-medium">角色信息</p>
				<div class="mt-20 mr-24 addRoleForm">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
						<el-form-item label="角色名称(必填)" prop="name" class="roleName">
							<el-input v-model="ruleForm.name" placeholder="请填写"></el-input>
						</el-form-item>
						<el-form-item label="角色状态" prop="status">
							<el-radio v-model="ruleForm.status" :label="0">启用</el-radio>
							<el-radio v-model="ruleForm.status" :label="1">禁用</el-radio>
						</el-form-item>
						<el-form-item label="备注(非必填)" prop="remark">
							<el-input v-model="ruleForm.remark" placeholder="请选择"></el-input>
						</el-form-item>
					</el-form>
				</div>

				<p class="mt-24 ml-24 yx-color-text-primary font-h4-medium">分配权限</p>
				<div class="mt-24 mr-24">
					<el-form :model="ruleForm" :rules="powerRules" ref="PowerRuleForm" label-width="105px">
						<el-form-item prop="dataScope" class="dataPower">
							<span slot="label">
								<Explain content="设置该角色可以在各个页面查看数据的范围">数据权限</Explain>
							</span>
							<el-select v-model="ruleForm.dataScope" placeholder="请选择" class="width100">
								<el-option :label="dict.label" :value="parseInt(dict.value)" v-for="dict in dataScopeDict" :key="dict.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="menuPower">
							<span class="star font-h3-regular"></span>
							<Explain
								content="设置该角色可以查看的页面和操作。仅针对达人运营生效的权限，需要子账号的用户类型包含“达人运营”时，才会生效。"
								class="menuPowerSon"
							>
								<span>菜单权限</span>
							</Explain>
							<Tree v-model="ruleForm.menuIds" ref="menu"></Tree>
						</el-form-item>
					</el-form>
				</div>
				<div class="demo-drawer__footer">
					<el-button @click="handleClose">取 消</el-button>
					<el-button type="primary" @click="submitAddRole">保存</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import Explain from '../explain/explain.vue';
import Tree from '../tree/tree.vue';
import { getRoleMenuPower, addRole, editRole } from '@/api/teamManage';
import { dataPower } from '@/utils/dataMap';
import throttle from 'lodash/throttle';
export default {
	name: 'addRoleDraw',
	data() {
		return {
			drawer: false,
			loading: false,
			ruleForm: {
				name: '',
				remark: '',
				status: 0,
				dataScope: '',
				code: '',
				menuIds: [],
			},
			rules: {
				name: [
					{ required: true, message: '请输入角色名称', trigger: 'blur' },
					{ min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
				],
			},
			powerRules: {
				dataScope: [{ required: true, message: '请选择', trigger: 'change' }],
			},
			drawerType: 0,
			dataPower,
			// 数据字典
			dataScopeDict: this.getDictDatas(this.DICT_TYPE.SYSTEM_DATA_SCOPE),
		};
	},

	props: {
		// 角色列表中排序最大的值，用于创建角色时设置排序值
		lastSortNumb: {
			type: [String, Number],
			default: 0,
		},
		// 当前选中的角色
		roleObj: {
			type: Object,
			default: () => {},
		},
	},
	components: { Explain, Tree },

	mounted() {},
	computed: {
		title() {
			return this.isAddRole ? '新增角色' : '编辑角色';
		},
		isAddRole() {
			return this.drawerType === 'add';
		},
		roleId() {
			return this.roleObj?.id;
		},
	},
	methods: {
		show(type) {
			// val=add表示新增，edit表示编辑角色
			this.drawerType = type;
			this.drawer = true;
			if (this.isAddRole) {
				// 菜单权限树设置为非严格，设置父节点自动选中子节点
				// this.$refs.menu.setCheckStric(false);
				return;
			}
			this.loading = true;
			// 设置表单数据为当前选中角色信息
			const { ruleForm } = this;
			ruleForm.name = this.roleObj.name || '';
			ruleForm.status = this.roleObj.status || 0;
			ruleForm.remark = this.roleObj.remark || '';
			ruleForm.dataScope = this.roleObj.dataScope || '';
			ruleForm.code = this.roleObj.code || '';
			ruleForm.sort = this.roleObj.sort || '';
			this.getRoleMenuPower(); //获取角色的菜单权限
		},
		//编辑角色获取当前角色的菜单权限
		async getRoleMenuPower() {
			const { roleId } = this;
			const data = await getRoleMenuPower({ roleIds: [roleId] });
			this.ruleForm.menuIds = data;
			this.loading = false;
		},
		//新增角色验证
		submitAddRole: throttle(function () {
			//先进行表单验证
			this.$refs.ruleForm.validate(valid => {
				if (valid) {
					this.$refs.PowerRuleForm.validate(valid => {
						if (valid) {
							this.isAddRole ? this.addRole() : this.editRole();
						}
					});
				}
			});
		}, 1000),
		async addRole() {
			const { ruleForm } = this;
			const { getCheckedKeys, getHalfCheckedKeys } = this.$refs.menu;
			let params = {
				...ruleForm,
				menuIds: [...getCheckedKeys(), ...getHalfCheckedKeys()],
				sort: this.lastSortNumb + 1,
				code: 1,
			};
			await addRole(params);
			this.$message.success('操作成功！');
			//增加角色以后需要刷新角色列表以及关闭Dialog框
			this.$emit('refresh', 1);
			this.handleClose();
		},
		async editRole() {
			const { ruleForm } = this;
			const { getCheckedKeys, getHalfCheckedKeys } = this.$refs.menu;
			let params = {
				...ruleForm,
				menuIds: [...getCheckedKeys(), ...getHalfCheckedKeys()],
				id: this.roleId,
			};
			await editRole(params);
			this.$message.success('操作成功！');
			this.$emit('refresh', 2);
			this.handleClose();
		},
		handleClose() {
			this.ruleForm = {
				name: '',
				remark: '',
				status: 0,
				dataScope: '',
				menuIds: [],
			};
			this.$refs.ruleForm.resetFields();
			this.$refs.PowerRuleForm.resetFields();
			this.$nextTick(() => {
				this.$refs.PowerRuleForm.clearValidate();
				this.drawer = false;
			});
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-form-item__label {
	font-family: PingFangSC-Regular;
	font-size: 14px;
	padding-right: 8px;
}

.demo-drawer__footer {
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	position: absolute;
	bottom: 0px;
	width: 100%;
	height: 64px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	z-index: 9999;

	&/deep/.el-button + .el-button {
		margin-right: 15px !important;
		margin-left: 16px !important;
		width: 88px;
	}

	&/deep/:first-child {
		width: 76px !important;
	}
}

/deep/ .menuPower .el-form-item__content {
	margin-left: 24px !important;
	margin-bottom: 84px !important;

	.el-form-item__error {
		position: relative;
		left: 3px;
	}
}

.star {
	position: absolute;
	left: -11px;
	color: red;
}

.allPower {
	position: absolute;
	right: 0px;
}

/deep/.el-checkbox__inner {
	border: 1px solid #e2e3e8 !important;
}
</style>
